import axios from "axios";

import baseDomain, { quoteAPI } from "../../Constants/apiRoutes";

export const createQuote = (data) => {
  return axios.post(`${baseDomain}${quoteAPI}`, data);
};
